<!--
 * @Description: 窄屏抽屉导航（≤1200px）
-->
<template>
  <div :class="$style['fold-drawer']" ref="rootDom" data-lenis-prevent>
    <div :class="$style['fold-mask']" @click="emitClose"></div>
    <aside :class="$style['fold-panel']">
      <div :class="$style['drawer-head']" class="flex items-center justify-between">
        <div :class="$style['drawer-logo']" class="pointer" @click="onLogoClick">
          <UtilSiteLogo :isPureColor="true"/>
        </div>
        <button :class="$style['btn--close-panel']" type="button" @click="emitClose" aria-label="close">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
            <path
                d="M18.7593 6.75999L6.2793 19.24M6.2793 6.75999L18.7593 19.24"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <UtilScrollBox :class="$style['scroll-box']">
        <div :class="$style['drawer-body']">
          <div :class="$style['section-label']">{{ $t('fold_nav.primary') }}</div>
          <div :class="$style['nav-block']">
            <div
                v-for="(item, index) in drawerPrimaryItems"
                :key="'nav-' + index"
                :class="$style['nav-item']"
                :data-state-open="subnavOpenState === 'primary-' + index"
            >
              <div
                  :class="$style['nav-item--inner']"
                  class="flex items-center justify-between"
                  @click="onPrimaryRowClick(item, 'primary-' + index)"
              >
                <span :class="$style['nav-item-title']">{{ item.title }}</span>
                <i v-if="item.subnav" :class="$style['nav-item-icon']" class="ueicon-arrow-down"></i>
              </div>
              <div v-if="item.subnav" :class="$style['subnav-collapse']">
                <div :class="$style['subnav-list']">
                  <div
                      v-for="(subItem, subIndex) in item.subnav"
                      :key="subIndex"
                      :class="$style['subnav-item']"
                      class="flex items-center"
                      @click.stop="onNavigate(subItem)"
                  >
                    <span :class="$style['subnav-item-title']">{{ subItem.title }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div
                :class="[$style['nav-item'], $style['nav-item--more']]"
                :data-state-open="subnavOpenState === 'more'"
            >
              <div
                  :class="$style['nav-item--inner']"
                  class="flex items-center justify-between"
                  @click="toggleSubnav('more')"
              >
                <span :class="$style['nav-item-title']">{{ $t('400094') }}</span>
                <i :class="$style['nav-item-icon']" class="ueicon-arrow-down"></i>
              </div>
              <div :class="$style['subnav-collapse']">
                <div :class="$style['subnav-list']">
                  <div v-for="(group, groupIndex) in moreNavGroups" :key="'g-' + groupIndex">
                    <div :class="$style['group-title']">{{ group.title }}</div>
                    <div
                        v-for="(subItem, subIndex) in group.items"
                        :key="'g-' + groupIndex + '-' + subIndex"
                        :class="$style['subnav-item']"
                        class="flex items-center"
                        @click.stop="onNavigate(subItem)"
                    >
                      <span :class="$style['subnav-item-title']">{{ subItem.title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div :class="$style['settings-divider']"></div>
          <div :class="$style['section-label']">{{ $t('fold_nav.account') }}</div>
          <div :class="$style['settings-list']">
            <button
                type="button"
                :class="$style['settings-row']"
                @click="onNotice"
            >
              <span>{{ $t('fold_nav.notice') }}</span>
            </button>
            <button
                type="button"
                :class="$style['settings-row']"
                @click="onDownload"
            >
              <span>{{ $t('fold_nav.download') }}</span>
            </button>
            <button
                type="button"
                :class="$style['settings-row']"
                @click="onLanguage"
            >
              <span>{{ $t('fold_nav.language') }}</span>
            </button>
            <div :class="[$style['settings-row'], $style['settings-row--theme']]">
              <span>{{ $t('fold_nav.theme') }}</span>
              <div :class="$style['theme-switch']">
                <button
                    type="button"
                    :class="$style['theme-btn']"
                    :data-active="styleType === 'sunlight'"
                    @click="onThemePick('sunlight')"
                >
                  <i class="ueicon-sun"></i>
                </button>
                <button
                    type="button"
                    :class="$style['theme-btn']"
                    :data-active="styleType === 'moon'"
                    @click="onThemePick('moon')"
                >
                  <i class="ueicon-moon"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </UtilScrollBox>
    </aside>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import UtilScrollBox from '../util/ScrollBox.vue'
import UtilSiteLogo from '../util/SiteLogo.vue'
import {useSiteNav} from '../../plugins/use-site-nav.js'
import {buildMainSiteUrl, navigateNavItem} from '@/utils/navigate-nav-item'

export default {
  name: 'SiteFoldNav',
  components: {UtilScrollBox, UtilSiteLogo},
  props: {
    styleType: {
      type: String,
      default: 'moon',
    },
    linkUrl: {
      type: String,
      default: '',
    },
    language: {
      type: String,
      default: 'en',
    },
  },
  data() {
    const {navList, moreNavGroups} = useSiteNav()
    return {
      subnavOpenState: -1,
      navList,
      moreNavGroups,
    }
  },
  computed: {
    ...mapGetters(['token', 'invitationCode']),
    /** 与桌面导航共用数据，更多为固定折叠项 */
    drawerPrimaryItems() {
      return this.navList.filter((item) => !item.isMore)
    },
  },
  methods: {
    emitClose() {
      this.$emit('close')
    },
    onLogoClick() {
      window.location.href = buildMainSiteUrl(this.linkUrl, '/index', this.language)
      this.emitClose()
    },
    onPrimaryRowClick(item, key) {
      if (item.subnav) {
        this.toggleSubnav(key)
        return
      }
      this.onNavigate(item)
    },
    toggleSubnav(index) {
      this.subnavOpenState = this.subnavOpenState === index ? -1 : index
    },
    onNavigate(item) {
      this.$store.dispatch('setGridType', item.tradeGroud ? 'grid' : item.tradeStock ? 'stock' : 'trade')
      navigateNavItem(item, {
        router: this.$router,
        linkUrl: this.linkUrl,
        token: this.token,
        invitationCode: this.invitationCode,
        language: this.language,
      })
      this.emitClose()
    },
    onLanguage() {
      this.$emit('open-language')
      this.emitClose()
    },
    onNotice() {
      this.$emit('notice')
      this.emitClose()
    },
    onDownload() {
      window.open(buildMainSiteUrl(this.linkUrl, '/download', this.language), '_blank')
      this.emitClose()
    },
    onThemePick(mode) {
      if (mode === this.styleType) return
      this.$emit('set-theme', mode)
    },
  },
}
</script>
<style lang="scss" module>
@import "../../assets/css/scss-utils/scss/abstracts/mixins";
@import "../../assets/css/scss-utils/scss/abstracts/_breakpoint";
@import "../../assets/css/variable";
@import "../../assets/css/mixin";
@import "../../assets/css/var";

:global(html[data-theme="sunlight"]) {
  .fold-mask {
    background: rgba(0, 0, 0, 0.45);
  }

  .fold-panel {
    background: #fff;

    .section-label {
      color: rgba(0, 0, 0, 0.45);
    }

    .nav-item--inner,
    .nav-item-title {
      color: rgba(0, 0, 0, 0.85);
    }

    .group-title {
      color: rgba(0, 0, 0, 0.45);
    }

    .subnav-item {
      &:hover,
      &:active {
        background: #f3f4f6;
      }
    }

    .settings-row {
      color: rgba(0, 0, 0, 0.85);

      &:hover {
        background: #f3f4f6;
      }
    }

    .theme-switch {
      background: #f5f7fa;
      border-color: #dcdfe6;
    }

    .theme-btn {
      color: #7f8490;

      &[data-active="true"] {
        color: #000922;
        background: #fff;
      }
    }

    .settings-divider::before {
      background: rgba(0, 0, 0, 0.03);
    }
  }
}

.fold-drawer {
  position: fixed;
  z-index: 1200;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.fold-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}

.fold-panel {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 320px;
  max-width: 100%;
  height: 100%;
  background: color(var(--site-background-color));
  box-shadow: -8px 0 40px rgba(0, 0, 0, 0.25);
}

:global(html[dir="rtl"]) {
  .fold-panel {
    right: auto;
    left: 0;
    box-shadow: 8px 0 40px rgba(0, 0, 0, 0.25);
  }
}

.drawer-head {
  box-sizing: border-box;
  flex-shrink: 0;
  height: 74px;
  padding: 21px 20px;
}

.drawer-logo {
  width: 121.427px;
}

.btn--close-panel {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 7px;
  color: color(var(--font-color));
  background: transparent;
  border: none;
  border-radius: 20px;
  cursor: pointer;

  > svg {
    width: 18px;
    height: 18px;
  }
}

.scroll-box {
  flex: 1;
  min-height: 0;
}

.drawer-body {
  padding: 0 0 32px;
}

.section-label {
  box-sizing: border-box;
  padding: 14px 20px 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  color: color(var(--font-color), 0.45);
}

.nav-block {
  padding: 0 20px 8px;
}

.nav-item {
  &[data-state-open="true"] {
    .nav-item-icon {
      transform: rotate(180deg);
    }

    .nav-item--inner {
      color: color(var(--theme-color));
    }

    .subnav-collapse {
      grid-template-rows: 1fr;
      opacity: 1;
      transform: translateY(0);

      .subnav-list {
        padding-bottom: 8px;
      }
    }
  }
}

.nav-item--inner {
  box-sizing: border-box;
  height: 56px;
  padding: 10px 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-theme-color);
  color: color(var(--font-color));
}

.nav-item-icon {
  font-size: 14px;
  transition: transform 0.2s ease;
}

.subnav-collapse {
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transform: translateY(-6px);
  transition:
    grid-template-rows 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.18s ease,
    transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.subnav-list {
  min-height: 0;
  padding-bottom: 0;
  overflow: hidden;
  transition: padding-bottom 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.group-title {
  padding: 12px 4px 6px;
  font-size: 12px;
  color: color(var(--font-color), 0.45);
}

.subnav-item {
  padding: 10px 4px 10px 12px;
  gap: 10px;
  cursor: pointer;
  transition: var(--transition-theme-color);

  &:hover {
    background: #202020;

    .subnav-item-title {
      color: color(var(--theme-color));
    }
  }
}

.subnav-item-title {
  font-size: 14px;
  font-weight: 500;
  color: color(var(--font-color));
}

.settings-divider {
  box-sizing: border-box;
  height: 17.5px;
  margin: 0 20px;

  &::before {
    display: block;
    width: 100%;
    height: 1.5px;
    margin-top: 8px;
    background: rgba(255, 255, 255, 0.06);
    content: '';
  }
}

.settings-list {
  padding: 0 20px 12px;
}

.settings-row {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  padding: 11px 4px;
  margin-bottom: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  color: color(var(--font-color));
  background: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: var(--transition-theme-color);
  text-align: left;

  &:hover {
    background: #202020;
  }
}

.settings-row--theme {
  cursor: default;

  &:hover {
    background: transparent;
  }
}

.theme-switch {
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: 82px;
  height: 30px;
  padding: 2px;
  margin-left: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  gap: 4px;
}

.theme-btn {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 24px;
  padding: 0;
  font-size: 18px;
  line-height: 1;
  color: color(var(--font-color), 0.45);
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s ease;

  &[data-active="true"] {
    color: color(var(--font-color));
    background: rgba(255, 255, 255, 0.12);
  }

  > i {
    display: block;
    width: 18px;
    height: 18px;
    font-size: 18px;
    line-height: 18px;
  }
}
</style>
